var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000244141 8C-0.000244141 12.4177 3.58116 16 7.99976 16C12.4175 16 15.9998 12.4177 15.9998 8C15.9998 3.58227 12.4175 0 7.99976 0C3.58116 0 -0.000244141 3.58227 -0.000244141 8Z",
    fill: "#00B396"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32397 8.10604L6.37716 10.1584L10.4818 6.05371",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick--green.d3d41ff4b01191b80ac8613f2e966694.svg";
export { ForwardRef as ReactComponent };